import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as apicall from "../../components/Apicall";
import Skeleton from "../../components/SekeltonLoder";
import BookingsIndictor from "./BookingsIndictor";
import { format, parseISO } from "date-fns";
import "../../App.css";
import PhoneInput from "react-phone-input-2";
import {
  FaArrowRight,
  FaCheckCircle,
  FaStar,
  FaTimesCircle,
} from "react-icons/fa";
import Table from "../../components/Table";
import Loader from "../../components/Loader";
import * as constants from "../../constants/Constants";
import PaymentLinkSection from "./PaymentLinkSection";

const service = ["Painting", "Water Tank", "Appliances Repair"];
const BookingDetails = () => {
  const { id: paramId } = useParams(); // from URL if available
  const location = useLocation();

  const bookingId = location?.state?.bookingId || paramId;
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState(-1);
  const [booking, setBooking] = useState(null);
  const [selectedVendorId, setSelectedVendorId] = useState();
  const [selectedDate, setSelectedDate] = useState("");
  const [serviceOfferings, setServiceOfferings] = useState([]);
  const [selectedOffering, setSelectedOffering] = useState(
    booking?.service_offering_id?.toString() || ""
  );
  const [isEzpSynced, setIsEzpSynced] = useState(null);
  const formatTimeToSlot = (time) => {
    if (!time) return "";
    const [hour, minute] = time.split(":").map(Number);

    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;

    return `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
  };

  const allowedStatuses = [
    "Cancelled by Admin",
    "Payment Pending",
    "Vendor Not Assigned",
    "Vendor Assigned",
    "Service Started",
    "Completed",
    "Worker Assigned",
    "Cancelled by User",
    "Cancelled by vendor",
  ];

  const [distance, setDistance] = useState();
  const [cash_handling_fee, setCash_handling_fee] = useState();
  const [selectedTime, setSelectedTime] = useState(booking?.service_time);
  const [bookingService, setBookingService] = useState("");
  const [vendors, setVendors] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [workersCount, setWorkersCount] = useState();
  const [selectedStatus, setSelectStatus] = useState();
  const [driverName, setDriverName] = useState();
  const [driverMobile, setDriverMobile] = useState();
  const [driverNumberError, setDriverNumberError] = useState("");
  const [isDriverNumberValid, setIsDriverNumberValid] = useState(true);
  const [selectedStatusId, setSelectedStatusId] = useState();
  const [selectedStatusName, setSelectedStatusName] = useState();
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState();
  const [vendor_payout_amount, setVendor_Payout_amount] = useState(
    booking?.vendor_payout_amount
  );
  const [partialPaymentNotes, setPartialPaymentNotes] = useState(
    booking?.partial_payment || ""
  );
  const [vendorAddOnPayment, setVendorAddOnPayment] = useState(
    booking?.vendor_add_on_payment || ""
  );

  const [userPayableAmount, setUserPayableAmount] = useState(
    booking?.user_total_payable_amount
  );
  const [cashPayment, setCashPayment] = useState(booking?.cash_payment || "");
  const [addOnPayment, setAddOnPayment] = useState(booking?.addon_payment);
  const [services, setServices] = useState([]);
  const [start_hour, setStartHours] = useState([]);
  const [end_hour, setEndHours] = useState();
  const [slots, setSlots] = useState([]);
  const [feedback, setFeedback] = useState();
  const [comments, setComments] = useState();
  const [feedbackDetails, setFeedbackDetails] = useState();
  const [contactDetails, setContactDetails] = useState();
  const [contact, setContact] = useState();
  const [reason, setReason] = useState();
  const [rating, setRating] = useState();
  const [followUpList, setFollowUpList] = useState();
  const [followUp, setFollowUp] = useState();
  const [vendorScheduledDate, setVendorScheduledDate] = useState();
  const [requestedDate, setRequestedDate] = useState();
  const [rescheduleReason, setRescheduleReason] = useState("");
  const [userRecords, setUserRecords] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("user_details"));
  const state = location.state || {};
  const d = state.bookingData || [];
  const isPartialPayment =
    selectedPaymentStatus === "12" ||
    selectedPaymentStatus === "Partial payment online";
  const handleViewOrder = (id) => {
    window.open(`/bookingDetails/${id}`, "_blank");
  };
  useEffect(() => {
    if (booking) {
      setSelectedPaymentStatus(booking.payment || "");
      setPartialPaymentNotes(booking.partial_payment || "");
    }
  }, [booking]);
  // const checkEzpSyncStatus = async () => {
  //   try {
  //     const response = await apicall.get(`checkEzpSyncStatus/${bookingId}`);

  //    if (response.status === 200) {
  //   const isSynced = response.data?.length > 0;
  //   setIsEzpSynced(isSynced);
  // }
  //   } catch (err) {
  //     console.error("EZP status fetch failed", err);
  //   }
  // };

  // useEffect(() => {
  //   if (bookingId) {
  //     checkEzpSyncStatus();
  //   }
  // }, [bookingId]);
  const normalizeTimeTo24Hour = (timeStr) => {
    if (!timeStr) return "";

    // Replace . with : (e.g., "09.30" → "09:30")
    let formatted = timeStr.replace(".", ":").trim().toUpperCase();

    // If the time string already includes AM/PM
    if (formatted.includes("AM") || formatted.includes("PM")) {
      const [time, modifier] = formatted.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours < 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      return `${String(hours).padStart(2, "0")}:${String(minutes || 0).padStart(
        2,
        "0"
      )}`;
    }

    // If no AM/PM is provided, assume it's in PM after 12:00 (your business logic)
    let [hour, minute] = formatted.split(":").map(Number);
    if (hour >= 1 && hour < 8) {
      // 👈 Example rule: assume evening times between 1–7 are PM (adjust as needed)
      hour += 12;
    }

    return `${String(hour).padStart(2, "0")}:${String(minute || 0).padStart(
      2,
      "0"
    )}`;
  };
  const handleVendorChange = async (vendorId) => {
    setSelectedVendorId(vendorId);

    if (!vendorId) {
      setVendor_Payout_amount(0);
      return;
    }

    try {
      const payload = {
        vendor_id: vendorId,
        service_offering_id: booking?.service_offering_id,
        service_state: booking?.service_state,
      };

      const res = await apicall.post(payload, "getVendorPayout");

      console.log(res, "res");

      if (res.success && res.data?.length > 0) {
        const payout = Number(res.data[0]?.payout_amount || 0);

        setVendor_Payout_amount(payout);
      } else {
        setVendor_Payout_amount(0);
      }
    } catch (err) {
      console.error("Error fetching payout:", err);
      setVendor_Payout_amount(0);
    }
  };
  const generateTimeSlots = (startTime, endTime, intervalInMinutes = 30) => {
    const slots = [];
    const start = new Date(`1970-01-01T${startTime}:00`);
    const end = new Date(`1970-01-01T${endTime}:00`);

    end.setHours(end.getHours() + 2); // if you want to extend the range by 2 hours

    while (start <= end) {
      const hours = String(start.getHours()).padStart(2, "0"); // 0-padded hour
      const minutes = String(start.getMinutes()).padStart(2, "0"); // 0-padded minute
      const timeStr = `${hours}:${minutes}`; // 24-hour format
      slots.push(timeStr);
      start.setMinutes(start.getMinutes() + intervalInMinutes);
    }

    return slots;
  };

  const handleServiceSelect = (service) => {
    setStartHours(service.start_hour);
    setEndHours(service.end_hour);

    const start = `${String(service.start_hour).padStart(2, "0")}:00`;
    const end = `${String(service.end_hour).padStart(2, "0")}:00`;

    const generatedSlots = generateTimeSlots(start, end);
    setSlots(generatedSlots);
  };
  useEffect(() => {
    if (booking?.display_service_id && services.length > 0) {
      const selectedService = services.find(
        (s) => s.service_id === booking?.display_service_id
      );
      if (selectedService) {
        handleServiceSelect(selectedService);
      }
    }
    setComments(booking?.customer_support_comments);
  }, [services, booking]);

  const fetchServices = async () => {
    try {
      const res = await apicall.get("services");
      setServices(res?.data);
      setStartHours(res?.data?.map((service) => service.start_hour));
      setEndHours(res?.data?.map((service) => service.end_hour));
    } catch (error) {
      console.error("Failed to fetch services:", error);
    }
  };
  useEffect(() => {
    fetchFeedback();
    fetchContactDetails();
    fetchServices();
    setVendor_Payout_amount(booking?.vendor_payout_amount);
    setUserPayableAmount(booking?.user_total_payable_amount);
    setCashPayment(booking?.cash_payment);
    setAddOnPayment(booking?.addon_payment);
    setVendorAddOnPayment(booking?.vendor_add_on_payment);
    setPartialPaymentNotes(booking?.partial_payment);

    const stepMap = { 2: 0, 3: 1, 9: 2, 4: 3, 5: 4 };
    const getStepFromStatus = (status) => {
      return ![1, 6, 7, 8].includes(status) ? stepMap[status] || 0 : -1;
    };

    const fetchBookingDetails = async () => {
      try {
        if (bookingId) {
          const response = await apicall.get(
            `admin_bookingDetails/${bookingId}`
          );
          const bookingData = response.data[0];
          setBooking(bookingData);
          setBookingService(bookingData.service_name);

          const status = bookingData.status;
          setCurrentStep(getStepFromStatus(status));
        }
        // 2. Else if state.bookingData exists → use that
        else if (location?.state?.bookingData?.length > 0) {
          const d = location.state.bookingData;
          setBooking(d[0]);
          setBookingService(d[0].service_name);
          setCurrentStep(getStepFromStatus(d[0].status));
        }
      } catch (error) {
        toast.error("Failed to load booking details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    const getVendorList = async () => {
      setLoading(true);
      try {
        const res = await apicall.get("vendor_data");
        setVendors(res.data);
        console.log("bookingService----", bookingService);
        if (bookingService) {
          const filtered = res.data.filter(
            (vendor) =>
              vendor.service?.toLowerCase() === bookingService.toLowerCase()
          );
          console.log("filtered---", filtered);
          setFilteredVendors(filtered);
        }
      } catch (e) {
        toast.error(e.message.replace("Error:", ""));
      } finally {
        setLoading(false);
      }
    };

    const getStatusList = async () => {
      setLoading(true);
      try {
        const res = await apicall.get("bookingStatus");
        const filteredBookings = res.data
          .filter((booking) => allowedStatuses.includes(booking.name))
          .filter(
            (booking, index, self) =>
              index === self.findIndex((b) => b.name === booking.name)
          );
        setSelectStatus(filteredBookings);
      } catch (e) {
        toast.error(e.message.replace("Error:", ""));
      } finally {
        setLoading(false);
      }
    };
    fetchBookingDetails();
    getStatusList();
    if (bookingService) {
      getVendorList();
    }
  }, [bookingId, bookingService]);
  const currentStatusText = allowedStatuses[booking?.status] || "";

  const handleDriverMobileChange = (value, country, formattedValue) => {
    setDriverMobile(value);
    const dialCode = country.dialCode;
    const nationalNumber = value.replace(dialCode, "").replace("+", "").trim();

    let isValid = false;

    if (country.countryCode === "ae") {
      isValid = nationalNumber.length === 9;
    } else if (country.countryCode === "in") {
      isValid = nationalNumber.length === 10;
    }

    if (isValid) {
      setIsDriverNumberValid(true);
      setDriverNumberError("");
    } else {
      setIsDriverNumberValid(false);
      setDriverNumberError(`Please enter a valid ${country.name} number`);
    }
  };

  const handleStatus = (e) => {
    const statusId = e.target.value;
    const status = selectedStatus.find((s) => s.id === statusId);
    setSelectedStatusId(statusId);
    setSelectedStatusName(status?.name);
  };
  const handleAddOnPaymentChange = (value) => {
    setAddOnPayment(value);

    const backendUserAmount = parseFloat(
      booking?.user_total_payable_amount || 0
    );
    const addOn = parseFloat(value || 0);

    const newTotal = backendUserAmount + addOn;
    setUserPayableAmount(newTotal.toFixed(2));
  };

  const pad = (n) => n.toString().padStart(2, "0");

  function formatLocalDate(date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}`;
  }
  console.log(selectedVendorId, "cash=========");

  const handleUpdateBooking = async () => {
    try {
      setLoading(true);
      if (selectedPaymentStatus === "12" && !cashPayment) {
        toast.error("Cash amount is required for partial payment");
        return;
      }
      const updates = {};
      let serviceOfferingUpdated = false;

      if (
        selectedVendorId &&
        selectedVendorId !== booking?.vendor?.toString()
      ) {
        updates.vendor_id = selectedVendorId;
      }

      if (
        selectedStatusId &&
        selectedStatusId !== booking?.status?.toString()
      ) {
        updates.status = selectedStatusId;
      }

      if (
        selectedOffering &&
        booking?.service_offering_id &&
        selectedOffering.toString() !== booking?.service_offering_id.toString()
      ) {
        if (booking?.service_name === "Packers & Movers") {
          updates.service_offering = selectedOffering;
          updates.from_state = booking?.from_state;
          updates.to_state = booking?.to_state;
          updates.service_date = selectedDate;
          updates.distance = booking?.distance;
          updates.service_name = booking?.service_name;
        } else {
          updates.service_offering = selectedOffering;
          updates.service_type = booking?.service_type_id;
          updates.service_state = booking?.service_state;
          updates.service_date = selectedDate;
          updates.service_name = booking?.service_name;
        }
        serviceOfferingUpdated = true;
      }

      console.log(
        "date--------",
        format(new Date(selectedDate), "yyyy-MM-dd") !==
          format(new Date(booking?.service_date), "yyyy-MM-dd")
      );
      console.log(selectedDate, new Date(selectedDate));
      console.log(booking?.service_date, new Date(booking?.service_date));
      booking.service_date = booking?.service_date.split(" ")[0];

      let s1 = new Date(selectedDate);
      let s2 = new Date(booking?.service_date);

      let d1 = s1.toLocaleDateString("en-GB").split(/[\/\-\.]/);
      let d2 = s2.toLocaleDateString("en-GB").split(/[\/\-\.]/);

      let formattedS1 = `${d1[0]}-${d1[1]}-${d1[2]}`;
      let formattedS2 = `${d2[0]}-${d2[1]}-${d2[2]}`;

      // let formattedS1 = formatLocalDate(s1);
      // let formattedS2 = formatLocalDate(s2);
      // let formattedS2 = `${d2[0]} - ${d2[1]} - ${d2[2]}`;

      console.log("d1,", d1, d2, formattedS1, formattedS2);

      if (
        selectedDate &&
        formattedS1 !== formattedS2
        // format(new Date(selectedDate), "yyyy-MM-dd") !==
        //   format(new Date(booking?.service_date), "yyyy-MM-dd")
      ) {
        if (!rescheduleReason && !booking?.reschedule_reason) {
          toast.error(
            "Please select a reason for rescheduling the booking date."
          );
          setLoading(false);
          return;
        }
        updates.new_date = selectedDate;
        updates.reschedule_reason = rescheduleReason;
      }

      if (selectedTime && selectedTime !== booking?.service_time) {
        updates.new_time = selectedTime;
      }

      if (
        selectedPaymentStatus &&
        selectedPaymentStatus !== booking?.payment?.toString()
      ) {
        updates.payment = selectedPaymentStatus;
      }

      if (
        vendor_payout_amount !== undefined &&
        vendor_payout_amount !== null &&
        Number(vendor_payout_amount) !==
          Number(booking?.vendor_payout_amount || 0)
      ) {
        updates.vendor_amount = Number(vendor_payout_amount);
      }
      if (
        vendorAddOnPayment &&
        vendorAddOnPayment !== booking?.vendor_add_on_payment?.toString()
      ) {
        updates.vendor_add_on_payment = vendorAddOnPayment;
      }
      if (cashPayment && cashPayment !== booking?.cash_payment?.toString()) {
        updates.cash_payment = cashPayment;
      }
      if (
        partialPaymentNotes &&
        partialPaymentNotes !== booking?.partial_payment?.toString()
      ) {
        updates.partial_payment = partialPaymentNotes;
      }

      if (
        userPayableAmount &&
        userPayableAmount !== booking?.user_total_payable_amount?.toString()
      ) {
        updates.user_amount = userPayableAmount;
      }
      if (addOnPayment && addOnPayment !== booking?.addon_payment?.toString()) {
        updates.addon_payment = addOnPayment;
      }

      if (driverName && driverName !== booking?.driver_name) {
        updates.driver_name = driverName;
      }
      if (driverMobile && driverMobile !== booking?.driver_mobile) {
        updates.driver_mobile = driverMobile;
      }

      if (
        workersCount &&
        workersCount.toString() !== booking?.workers_count?.toString()
      ) {
        updates.workers_count = workersCount;
      }

      if (feedback && feedback !== booking?.timeliness) {
        updates.timeliness = feedback;
      }
      if (
        rating !== undefined &&
        rating !== null &&
        Number(rating) !== Number(booking?.portal_rating)
      ) {
        updates.portal_rating = Number(rating);
      }

      if (
        requestedDate &&
        format(new Date(requestedDate), "yyyy-MM-dd") !==
          format(new Date(booking?.customer_requesteddate), "yyyy-MM-dd")
      ) {
        updates.customer_requesteddate = requestedDate;
      }
      if (
        vendorScheduledDate &&
        format(new Date(vendorScheduledDate), "yyyy-MM-dd") !==
          format(new Date(booking?.vendor_scheduledDate), "yyyy-MM-dd")
      ) {
        updates.vendor_scheduledDate = vendorScheduledDate;
      }
      if (followUp && followUp !== booking?.status_followup?.toString()) {
        updates.status_followup = followUp;
      }
      if (contact && contact !== booking?.utilstop_contact?.toString()) {
        updates.utilstop_contact = contact;
      }
      if (
        comments &&
        comments !== booking?.customer_support_comments?.toString()
      ) {
        updates.customer_support_comments = comments;
      }

      if (Object.keys(updates).length === 0) {
        toast.info("No changes detected");
        return;
      }

      updates.booking_id = booking?.id;
      console.log(updates, "updates");

      const response = await apicall.post(updates, "/update_bookingDetails");
      if (response.status === 200) {
        toast.success("Booking updated successfully!");
        if (selectedVendorId) {
          try {
            await apicall.post(
              {
                booking_id: booking?.id,
                vendor_id: selectedVendorId,
              },
              "/syncToEzeitpro"
            );

            toast.success("Synced to Ezeitpro successfully!");
          } catch (syncError) {
            console.error("EZP Sync Failed:", syncError);

            toast.error(
              "Booking updated, but sync to Ezeitpro failed. Please contact tech support.",
              { autoClose: 5000 }
            );
          }
        }
        if (serviceOfferingUpdated) {
          await getPaymentDetails(booking?.id);
        }
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        // window.location.reload();
      }
    } catch (err) {
      toast.error("Update failed!");
    } finally {
      setLoading(false);
    }
  };
  const getPaymentDetails = async (booking_id) => {
    try {
      var res = await apicall.get(`/getPaymentAdmin/${booking_id}`);
      systemCalculation(res.data[0]);
    } catch (e) {
      toast.error(e.message?.replace("Error:", ""));
    }
  };
  const systemCalculation = async (data) => {
    try {
      let system_payment = data ? data : system_payment;

      const average_price = parseFloat(system_payment.average_price).toFixed(2);
      const admin_fee = parseFloat(
        (average_price / 100) * system_payment.admin_percenatege
      ).toFixed(2);

      const offered_price = parseFloat(average_price) + parseFloat(admin_fee);

      const total_tax_percentage = parseInt(
        system_payment.vat?.replace("%", "")
      );

      const total_tax = (
        (parseFloat(offered_price) * total_tax_percentage) /
        100
      ).toFixed(2);

      const platform_fee = parseFloat(system_payment.platform_fee).toFixed(2);
      const fee = parseFloat(system_payment.cash_handling_fee).toFixed(2);

      let total = parseFloat(
        parseFloat(offered_price) +
          parseFloat(total_tax) +
          parseFloat(platform_fee) +
          parseFloat(fee)
      ).toFixed(2);

      const total_discount = total;

      await pay({
        admin_fee,
        platform_fee,
        total,
        total_discount,
        tax: total_tax,
        fee,
      });
    } catch (e) {
      console.log("err--", e, e.message);
    }
  };
  const pay = async ({
    admin_fee,
    platform_fee,
    total,
    tax,
    fee,
    total_discount,
  }) => {
    let paymentCapture;
    if (selectedPaymentStatus === 5) {
      paymentCapture = "After Service";
    } else {
      paymentCapture = selectedPaymentStatus === 1 ? "NOW" : "LATER";
    }
    let cash_handling_fee = 0;
    if (
      booking.payment === "Cash on service" ||
      booking.payment === "Cash Paid"
    ) {
      cash_handling_fee = fee;
    }
    const data = {
      quoted_price: "",
      total,
      total_discount,
      tax,
      platform_fee,
      admin_margin: admin_fee,
      booking_id: booking?.id,
      coupon: null,
      coupon_discount: "0",
      payment_capture: paymentCapture,
      wallet: "",
      cash_handling_fee,
    };
    try {
      const initPayment = await apicall.post(data, "init_payment");
    } catch (e) {
      console.log("err--", e, e.message);
    }
  };

  const getDistance = async (pickupAddress, dropAddress) => {
    try {
      if (pickupAddress.state === dropAddress.state) {
        setDistance(1);
        return;
      }

      const body = {
        pickupAddress_lat: pickupAddress.latitude,
        pickupAddress_lng: pickupAddress.longitude,
        dropAddress_lat: dropAddress.latitude,
        dropAddress_lng: dropAddress.longitude,
        keyUrl: constants.google_distance_key,
      };

      const res = await apicall.post(body, "get_distance");
      const distanceText = res.result.rows[0]?.elements[0]?.distance?.text;

      if (distanceText) {
        const distance_in_km = parseFloat(
          distanceText.replace(" km", "").trim()
        );
        setDistance(distance_in_km);
      } else {
        setDistance(1);
      }
    } catch (error) {
      console.error("Error fetching distance:", error.message);
      setDistance(1);
    }
  };

  useEffect(() => {
    if (booking?.p_lat && booking?.p_lng && booking?.d_lat && booking?.d_lng) {
      const pickupAddress = {
        latitude: booking?.p_lat,
        longitude: booking?.p_lng,
        state: booking.from_state,
      };
      const dropAddress = {
        latitude: booking?.d_lat,
        longitude: booking?.d_lng,
        state: booking.to_state,
      };
      getDistance(pickupAddress, dropAddress);
    }
  }, [booking]);
  useEffect(() => {
    getUserRecords();
    if (booking?.service_date) {
      const formatted = format(parseISO(booking.service_date), "yyyy-MM-dd");
      setSelectedDate(formatted);
    }
    if (booking?.service_time) {
      const normalizedTime = normalizeTimeTo24Hour(booking.service_time);
      setSelectedTime(normalizedTime);
    }

    if (!selectedVendorId && booking) {
      setDriverName(booking.driver_name || "");
      setDriverMobile(booking.driver_mobile || "");
      setWorkersCount(booking.workers_count || "");
    }
    if (booking?.customer_requesteddate) {
      const formatted = format(
        parseISO(booking.customer_requesteddate),
        "yyyy-MM-dd"
      );
      setRequestedDate(formatted);
    }
    if (booking?.vendor_scheduledDate) {
      const formatted = format(
        parseISO(booking.vendor_scheduledDate),
        "yyyy-MM-dd"
      );
      setVendorScheduledDate(formatted);
    }

    if (selectedVendorId && selectedVendorId !== booking?.vendor_id) {
      setDriverName("");
      setDriverMobile("");
      setWorkersCount("");

      fetchVendorDetails(selectedVendorId);
    }
  }, [booking, selectedVendorId, booking?.service_time]);
  const getUserRecords = async () => {
    if (!booking?.user_id) {
      console.warn("No user_id found in booking");
      return;
    }

    setLoading(true);
    try {
      const res = await apicall.get(
        `get_user_records/${booking.user_id}/${booking?.id}`
      );
      setUserRecords(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

  const fetchVendorDetails = async (vendorId) => {
    try {
      const res = await apicall.get(
        `/vendor_details/${vendorId}/${booking?.service_id}`
      );
      const vendor = res.data[0];
      setDriverName(vendor?.operator_name || "");
      setDriverMobile(vendor?.operator_contact_number || "");
      setWorkersCount(
        vendor?.workers_count !== undefined && vendor?.workers_count !== null
          ? vendor?.workers_count
          : ""
      );
    } catch (err) {
      console.error("Failed to fetch vendor details:", err);
    }
  };
  const fetchContactDetails = async () => {
    try {
      const res = await apicall.get(`/get_contact`);
      setContactDetails(res?.data);
    } catch (err) {
      toast.error("Failed to fetch feedback details: " + err.message);
    }
  };

  const fetchFeedback = async () => {
    try {
      const res = await apicall.get(`/feedback_details`);
      if (res?.data) {
        const feedbackList = res?.data;

        const cancellations = feedbackList?.filter(
          (f) => f.category === "Cancellation"
        );
        const ratings = feedbackList?.filter((f) => f.category === "Rating");
        const followup = feedbackList?.filter((f) => f.category === "FollowUp");

        setFeedbackDetails(ratings);
        setReason(cancellations);
        setFollowUpList(followup);
      }
    } catch (err) {
      toast.error("Failed to fetch feedback details: " + err.message);
    }
  };

  const bookingHeaders = [
    "Booking Id",
    "Service",
    "Service Type",
    "Service Offering",
    "Service Date",
    "Service Time",
    "Status",
    "Vendor",
  ];

  const isPackers = booking?.service_name === "Packers & Movers";
  const ddmmyyyy = (dateObj) => {
    const d = new Date(dateObj);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };
  const fetchServiceOfferings = async (
    service_id,
    service_type_id,
    selectdate,
    state
  ) => {
    try {
      const body = {
        date: ddmmyyyy(new Date(selectdate)),
        state1: state,
        state2: state,
      };
      const res = await apicall.post(
        body,
        `service_offerings/${service_id}/${service_type_id}`
      );
      setServiceOfferings(res.data);
    } catch (err) {
      console.error("Error fetching offerings:", err);
    }
  };
  useEffect(() => {
    if (booking?.service_id && selectedDate && booking?.service_state) {
      fetchServiceOfferings(
        booking?.service_id,
        booking.service_type_id || 0,
        selectedDate,
        booking?.service_state
      );
    }
  }, [
    booking?.service_id,
    booking?.service_type_id,
    selectedDate,
    booking?.service_state,
  ]);
  const fetchPackersServiceOfferings = async (
    service_id,
    selectdate,
    pickupState,
    dropState,
    rawDistance
  ) => {
    try {
      const body = {
        distance: parseFloat(rawDistance) || 1,
        date: ddmmyyyy(new Date(selectdate)),
        state1: pickupState,
        state2: dropState,
      };

      const res = await apicall.post(body, `service_offerings/${service_id}`);
      setServiceOfferings(res.data);
      // console.log(res)
    } catch (err) {
      alert("Something went wrong");
    }
  };
  useEffect(() => {
    // Only run if all required fields are available
    if (
      booking?.service_id != null &&
      selectedDate != null &&
      booking?.from_state &&
      booking?.to_state &&
      distance != null
    ) {
      fetchPackersServiceOfferings(
        booking.service_id,
        selectedDate,
        booking.from_state,
        booking.to_state,
        distance
      );
    }
  }, [booking, selectedDate, distance]);

  const syncToEzeitpro = async () => {
    try {
      setLoading(true);
      let data = {
        booking_id: booking?.id,
        vendor_id: selectedVendorId,
      };
      const response = await apicall.post(data, "/syncToEzeitpro");
      if (response.status === 200) {
        toast.success("Booking Synced to Ezeitpro successfully!");
        setLoading(false);
        // window.location.reload();
      }
      setLoading(false);
    } catch (e) {
      console.log("error syncing to ezeitpro", e);
    }
  };

  return (
    <div className="container my-4 p-3 bg-white rounded-3">
      <div className="mb-2 d-flex align-items-center">
        <h1 className="sub-heading mb-0">Booking Details</h1>
      </div>

      <div className="row">
        <div className="col-md-6 mt-2">
          <div className="m-2 p-2">
            <p className="sub-heading">Service Details</p>
            <div className="row">
              <div className="col-md-6 mb-3">
                <h1 className="label">Service Name</h1>
                <p className="content">{booking?.service_name || "-"}</p>
              </div>

              <div className="col-md-6 mb-3">
                <h1 className="label">Selected Offerings</h1>
                <p className="content">
                  {booking?.service_offering_name || "-"}
                </p>
                <select
                  disabled={booking?.booking_status === "Completed"}
                  id="serviceOffering"
                  name="serviceOffering"
                  className="form-control mb-2"
                  value={selectedOffering}
                  onChange={(e) => setSelectedOffering(e.target.value)}
                >
                  <option value="">Select Offering</option>
                  {serviceOfferings.map((service) => (
                    <option key={service.id} value={service.id}>
                      {service.name}
                    </option>
                  ))}
                </select>
              </div>

              {booking?.service_type_name && (
                <div className="col-md-6 mb-3">
                  <h1 className="label">Selected Service Type</h1>
                  <p className="content">{booking?.service_type_name}</p>
                </div>
              )}
              {["Cleaning Service", "Hourly Deep Cleaning"].includes(
                booking?.service_name
              ) &&
                booking?.gender && (
                  <div className="col-md-6 mb-3">
                    <h1 className="label">Selected Preference</h1>
                    <p className="content">{booking?.gender}</p>
                  </div>
                )}

              {booking?.people_count > 0 && (
                <div className="col-md-6 mb-3">
                  <h1 className="label">Selected Cleaner Count</h1>
                  <p className="content">{booking?.people_count}</p>
                </div>
              )}

              <div className="col-md-6 mb-3">
                <h1 className="label">Booking ID</h1>
                <p className="content">{booking?.display_booking_id || "-"}</p>
              </div>

              <div className="col-md-6 mb-3">
                <h1 className="label">Booking Date</h1>
                <p className="content">
                  {booking?.bookingData
                    ? format(parseISO(booking.bookingData), "dd-MM-yyyy")
                    : "-"}
                </p>
              </div>
              <div className="col-md-6 mb-3">
                <h1 className="label">Service Time Slot</h1>
                <select
                  id="servicetime"
                  name="servicetime"
                  className="form-control"
                  disabled={booking?.booking_status === "Completed"}
                  value={selectedTime || ""}
                  onChange={(e) => setSelectedTime(e.target.value)}
                >
                  <option value="">Select Time</option>
                  {slots.map((slot, index) => (
                    <option key={index} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <h1 className="label">Service Date</h1>
                <input
                  disabled={booking?.booking_status === "Completed"}
                  type="date"
                  className="form-control"
                  value={selectedDate || booking?.service_date?.split("T")[0]}
                  onChange={(e) => {
                    setSelectedDate(e.target.value);
                    if (
                      booking?.service_date?.split("T")[0] !== e.target.value
                    ) {
                      setRescheduleReason("");
                    }
                  }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <h1 className="label">Reason for Reschedule</h1>
                <select
                  disabled={booking?.booking_status === "Completed"}
                  className="form-select"
                  value={rescheduleReason || booking?.reschedule_reason}
                  onChange={(e) => setRescheduleReason(e.target.value)}
                >
                  <option value="">Select reason</option>
                  {reason?.map((f) => (
                    <option key={f.id} value={f.value}>
                      {f.value}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-1 vertical-line mt-3"></div>
        <div className="col-md-5 mt-2">
          {/* User Details */}
          <div className="m-2 p-2">
            <h2 className="sub-heading">User Details</h2>
            <div className="row">
              <div className="col-md-6 mt-2">
                <h1 className="label">Customer Name</h1>
                <p className="content">
                  {booking
                    ? booking.user_name || "-"
                    : d[0]?.user_name || <Skeleton />}
                </p>

                <h1 className="label">Customer’s Email</h1>
                <p className="content">
                  {booking
                    ? booking.user_email || "-"
                    : d[0]?.user_email || <Skeleton />}
                </p>
              </div>

              <div className="col-md-6 mt-2">
                <h1 className="label">Customer’s Contact</h1>
                <p className="content">
                  {booking
                    ? booking.user_phone_number || "-"
                    : d[0]?.user_phone_number || <Skeleton />}
                </p>
              </div>
            </div>
          </div>

          {/* Feedback Section */}
          <div className="m-2 p-3 bg-white rounded shadow-sm">
            <h2 className="sub-heading mb-3">Feedback</h2>

            <div className="row g-4">
              {/* Timeliness */}
              <div className="col-md-6">
                <label className="label">Timeliness</label>

                <div className="mb-2 text-muted">
                  {booking ? booking.timeliness : <Skeleton />}
                </div>

                <select
                  className="form-select"
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                >
                  <option value="">Select feedback</option>
                  {feedbackDetails?.map((f) => (
                    <option key={f.id} value={f.value}>
                      {f.value}
                    </option>
                  ))}
                </select>
              </div>

              {/* Service Feedback */}
              <div className="col-md-6">
                <label className="label">Service Feedback</label>

                {booking?.portal_rating && (
                  <div className="d-flex align-items-center mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <FaStar
                        key={star}
                        size={24}
                        className="me-1"
                        color={
                          star <= (rating || booking.portal_rating)
                            ? "#ffc107"
                            : "#e4e5e9"
                        }
                      />
                    ))}
                  </div>
                )}

                <select
                  className="form-select"
                  value={rating}
                  onChange={(e) => setRating(Number(e.target.value))}
                >
                  <option value="">Select rating</option>
                  {[1, 2, 3, 4, 5].map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </select>
              </div>

              {/* Customer Support Comments */}
              <div className="col-12">
                <label className="label">Customer Support Comments</label>

                {/* <div className="mb-2 text-muted">
        {booking ? booking.customer_support_comments || "-" : <Skeleton />}
      </div> */}

                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Enter comments"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {(currentStep !== -1 || [6, 7 , 8].includes(Number(booking?.status))) && (
        <>
          <hr />

  <div className="row">
  <div className="col-md-2 mt-4 mx-4">
    <p className="mx-5">Status:</p>
  </div>

  <div className="col-md-8 m-1 p-1">
    {[6, 7, 8].includes(Number(booking?.status)) ? (
      <div
        className="d-flex align-items-center p-3 rounded"
        style={{
          backgroundColor: "#fff5f5",
          borderLeft: "5px solid #dc3545",
          border: "1px solid #f5c2c7",
        }}
      >
        <i
          className="fa fa-times-circle text-danger me-3"
          style={{ fontSize: "24px" }}
        />

        <div>
          <h6 className="mb-1 text-danger fw-bold">
            {Number(booking?.status) === 6
              ? "Cancelled by User"
              : Number(booking?.status) === 7
              ? "Cancelled by Vendor"
              : "Cancelled by Admin"}
          </h6>

          <small className="text-muted">
            {Number(booking?.status) === 6
              ? "The customer cancelled this booking."
              : Number(booking?.status) === 7
              ? "This booking was cancelled by the vendor."
              : "This booking was cancelled by the admin."}
          </small>
        </div>
      </div>
    ) : (
      <BookingsIndictor currentStep={currentStep} />
    )}
  </div>
</div>
        </>
      )}
      <hr />
      <div className="row">
        <div className="col-md-6 mt-2">
          <div className="m-2 p-3">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <p className="sub-heading mb-0">Vendor Details</p>

              {booking?.booking_mode === "EZP" ? (
                <span
                  style={{
                    backgroundColor: "#d4edda",
                    color: "#155724",
                    padding: "5px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  <FaCheckCircle /> Synced from EZP
                </span>
              ) : booking?.is_synced === null ? (
                <span style={{ color: "#999", fontSize: "12px" }}>
                  Checking...
                </span>
              ) : booking?.is_synced === 1 ? (
                <span
                  style={{
                    backgroundColor: "#d4edda",
                    color: "#155724",
                    padding: "5px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  <FaCheckCircle /> Synced
                </span>
              ) : (
                <span
                  style={{
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    padding: "5px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  <FaTimesCircle /> Not Synced
                </span>
              )}
            </div>

            <div className="row">
              <div className="col-md-6">
                <p className="label mb-1">Allotted Vendor's Name</p>
                <p className="content mb-3">
                  {booking ? booking.vendor_name || "-" : <Skeleton />}
                </p>

                <label htmlFor="vendorname" className="label mb-1">
                  Select Vendor
                </label>
                <select
                  disabled={booking?.booking_status === "Completed"}
                  id="vendorname"
                  name="vendorname"
                  className="form-select mb-3"
                  value={selectedVendorId}
                  onChange={(e) => handleVendorChange(e.target.value)}
                >
                  <option value="">Select Vendor</option>
                  {filteredVendors.length > 0 ? (
                    filteredVendors.map((vendor) => (
                      <option key={vendor?.vendor_id} value={vendor?.vendor_id}>
                        {vendor?.vendor_name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No vendors available</option>
                  )}
                </select>

                <p className="label mb-1">Transaction ID</p>
                <p className="content mb-3">-</p>

                <p className="label mb-1">Payment Status</p>
                <p className="content text-success mb-3">
                  {booking
                    ? booking.vendor_payout == 0
                      ? "Pending"
                      : "Completed"
                    : d[0]?.vendor_payout == 0
                    ? "Pending"
                    : "Completed" || <Skeleton />}
                </p>
              </div>

              <div className="col-md-6">
                <p className="label mb-1">Vendor's Contact</p>
                <p className="content mb-3">
                  {booking
                    ? booking.vendor_mobile || "-"
                    : d[0]?.vendor_mobile || <Skeleton />}
                </p>

                <label className="label mb-1">Vendor Payment</label>
                <input
                  disabled={booking?.booking_status === "Completed"}
                  type="number"
                  className="form-control mb-3"
                  value={vendor_payout_amount}
                  onChange={(e) => setVendor_Payout_amount(e.target.value)}
                />

                <p className="label mb-1">Total amount (incl. Taxes)</p>
                <p className="content">
                  {booking ? (
                    booking.vendor_payout_with_fee || "-"
                  ) : (
                    <Skeleton />
                  )}
                </p>
                <label className="label mb-1">Vendor Add on Payment</label>
                <input
                  // disabled={booking?.booking_status === "Completed"}
                  type="number"
                  className="form-control mb-3"
                  value={vendorAddOnPayment}
                  onChange={(e) => setVendorAddOnPayment(e.target.value)}
                />

                {/* {selectedVendorId && ( */}
                {/* <button
                    onClick={syncToEzeitpro}
                    className="border-0 btn btn-primary primaryBackground"
                  >
                    Sync to Ezeitpro
                  </button> */}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-1 vertical-line mt-2"></div>

        <div className="col-md-5 mt-2">
          <div className="m-2 p-3">
            <p className="sub-heading">
              {isPackers ? "Driver Details" : "Worker Details"}
            </p>
            <div className="row">
              <div className="col-md-6">
                <p className="label">
                  {isPackers ? "Driver Name" : "Worker Name"}
                </p>

                <input
                  disabled={booking?.booking_status === "Completed"}
                  type="text"
                  className="form-control mb-3"
                  value={driverName}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                    setDriverName(value);
                  }}
                  placeholder="Enter name"
                />

                <p className="label">Workers Count</p>
                <input
                  disabled={booking?.booking_status === "Completed"}
                  type="text"
                  className="form-control mb-3"
                  value={workersCount}
                  onChange={(e) => setWorkersCount(e.target.value)}
                />
              </div>

              <div className="col-md-6">
                <p className="label">
                  {isPackers
                    ? "Driver Contact Number"
                    : "Worker Contact Number"}
                </p>
                <div className="mb-3">
                  <PhoneInput
                    disabled={booking?.booking_status === "Completed"}
                    onlyCountries={["in", "ae"]}
                    country={"in"}
                    value={driverMobile}
                    onChange={(value, country, formattedValue) =>
                      handleDriverMobileChange(value, country, formattedValue)
                    }
                    inputStyle={{ width: "100%" }}
                  />
                  {!isDriverNumberValid && (
                    <div className="text-danger mt-1">{driverNumberError}</div>
                  )}
                </div>
                <div className="mb-3">
                  <p className="label">Status</p>
                  <select
                    disabled={booking?.booking_status === "Completed"}
                    id="Status"
                    name="Status"
                    className="form-select"
                    onChange={handleStatus}
                    value={selectedStatusId}
                  >
                    <option value="">Select Status</option>
                    {selectedStatus?.length > 0 &&
                      selectedStatus.map((vendor) => (
                        <option key={vendor.id} value={vendor.id}>
                          {vendor.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div className="row">
        <div className="col-md-6 mt-2">
          <div className="m-2 p-2">
            <p className="sub-heading">Payment Details</p>
            <div className="row">
              {[
                { label: "Transaction ID", key: "transaction_id" },
                {
                  label: "User quoted amount",
                  key: "quoted_price",
                  className: "text-success",
                },
                { label: "Used coupon Code", key: "coupon_code" },
                {
                  label: "Coupon discount",
                  key: "coupon_discount",
                  className: "text-danger",
                },
                { label: "Wallet", key: "wallet" },
                { label: "Taxes", key: "taxes" },
                { label: "Convenience/Platform fees", key: "platform_fee" },
                { label: "User Order Amount ", key: "user_payable_amount" },
                { label: "Add on amount", key: "add_on_payment" },
                {
                  label: "User Totally Paid",
                  key: "user_total_payable_amount",
                },

                // keep cash_amount here in same position
                { label: "Cash amount", key: "cash_amount" },
              ].map(({ label, key, className = "" }, index) => {
                if (key === "cash_amount" && !isPartialPayment) {
                  return null;
                }

                return (
                  <div className="col-md-12 mb-2" key={index}>
                    <div className="d-flex justify-content-between align-items-center">
                      <h1 className={`label ${className}`}>{label}</h1>

                      {key === "add_on_payment" ? (
                        <input
                          type="number"
                          value={addOnPayment}
                          onChange={(e) =>
                            handleAddOnPaymentChange(e.target.value)
                          }
                          style={{
                            width: "150px",
                            padding: "6px 10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "14px",
                          }}
                        />
                      ) : key === "user_total_payable_amount" ? (
                        <input
                          type="number"
                          value={userPayableAmount}
                          disabled
                          style={{
                            width: "150px",
                            padding: "6px 10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "14px",
                            backgroundColor: "#f9f9f9",
                          }}
                        />
                      ) : key === "cash_amount" ? (
                        <input
                          type="number"
                          value={cashPayment}
                          onChange={(e) => setCashPayment(e.target.value)}
                          style={{
                            width: "150px",
                            padding: "6px 10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "14px",
                          }}
                        />
                      ) : (
                        <p className="content">
                          {booking
                            ? booking[key] ?? "-"
                            : d[0]?.[key] ?? <Skeleton />}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}

              <hr className="my-3" />

              <div className="row">
                <div className="col-md-6 mb-3">
                  <h1 className="label">Payment Status</h1>
                  <p className="content">
                    {booking
                      ? booking.payment || "-"
                      : d[0]?.payment || <Skeleton />}
                  </p>
                  <select
                    className="form-select"
                    value={selectedPaymentStatus}
                    onChange={(e) => setSelectedPaymentStatus(e.target.value)}
                  >
                    <option value="">Select Payment Status</option>
                    <option value="0">Payment not done</option>
                    {userDetails?.role !== 2 && (
                      <>
                        <option value="1">Payment initiated - Pending</option>
                        <option value="2">Pay later initiated - Pending</option>
                        <option value="3">Pay later successful/received</option>
                        <option value="4">Paid online</option>
                      </>
                    )}
                    <option value="5">Cash on service</option>
                    <option value="6">Cash Paid</option>
                    <option value="7">Paid through link</option>
                    <option value="8">Pay later amount received</option>
                    <option value="9">Refund completed</option>
                    <option value="10">Complimentary order</option>
                    <option value="11">Subscription Service</option>
                    <option value="12">Partial payment online</option>
                  </select>
                  {isPartialPayment && (
                    <div className="mt-3">
                      <label className="label">Notes</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter notes"
                        value={partialPaymentNotes}
                        onChange={(e) => setPartialPaymentNotes(e.target.value)}
                      />
                    </div>
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <h1 className="label">Package Type</h1>
                  <p className="content">-</p>
                </div>
              </div>

              {booking && (
                <PaymentLinkSection
                  booking={booking}
                  isAdmin={
                    Number(userDetails?.role ?? localStorage.getItem("role")) ===
                    constants.admin_role_id
                  }
                  onBookingUpdated={() => window.location.reload()}
                />
              )}
            </div>
          </div>
        </div>

        <div className="col-md-1 vertical-line mt-2"></div>

        <div className="col-md-5 mt-2">
          <div className="m-2 p-2">
            <h2 className="sub-heading">Service Locations</h2>

            <div className="mb-4">
              <h1 className="label mt-2">
                {booking?.service_name === "Packers & Movers"
                  ? "Pickup Location"
                  : "Service Location"}
              </h1>
              <p className="content">{booking?.pickup_location || "-"}</p>
              <div className="content">
                <h1 className="label">House No:</h1>
                <p className="content">
                  {booking ? booking.house_no || "-" : <Skeleton />}
                </p>
                <h1 className="label">Area:</h1>
                <p className="content">
                  {booking ? booking.area || "-" : <Skeleton />}
                </p>
                <h1 className="label">Landmark:</h1>
                <p className="content">
                  {booking ? booking.landmark || "-" : <Skeleton />}
                </p>
                <div>
                  {booking?.service_name === "Packers & Movers"
                    ? "Pickup  Map:"
                    : "Service Location Map"}
                  {booking?.pickup_map_link ? (
                    <a
                      href={booking.pickup_map_link}
                      style={{ color: "#d01c4c" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {booking.pickup_map_link}
                    </a>
                  ) : (
                    "-"
                  )}
                </div>
              </div>
            </div>

            {booking?.drop_location && (
              <div>
                <h1 className="label mt-4">Drop Location</h1>
                <p className="content">{booking.drop_location}</p>
                <div className="content">
                  <h1 className="label">House No:</h1>
                  <p className="content">
                    {booking ? booking.d_house_no || "-" : <Skeleton />}
                  </p>
                  <h1 className="label">Area:</h1>
                  <p className="content">
                    {booking ? booking.d_area || "-" : <Skeleton />}
                  </p>
                  <h1 className="label">Landmark:</h1>
                  <p className="content">
                    {booking ? booking.d_landmark || "-" : <Skeleton />}
                  </p>
                  <div>
                    <strong>Drop Map:</strong>{" "}
                    {booking?.drop_map_link ? (
                      <a
                        href={booking.drop_map_link}
                        style={{ color: "#d01c4c" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {booking.drop_map_link}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-md-6 mt-2">
          <div className="m-2 p-2">
            <p className="sub-heading">Attachments</p>
            <p className="label">Description</p>
            <p>{booking ? booking.item_details || "-" : <Skeleton />}</p>

            <p className="label">Attached Pictures</p>
            <div className="d-flex flex-wrap">
              {booking?.image_list.map((image, idx) => (
                <img
                  key={idx}
                  src={image}
                  alt={`Image ${idx + 1}`}
                  style={{
                    height: "120px",
                    width: "100px",
                    marginRight: "15px",
                    marginBottom: "10px",
                  }}
                  className="rounded"
                />
              ))}
            </div>
          </div>
          <hr />
          {/* <div className="col-md-12 mt-2">
            <div className="row">
              <div className="col-md-6">
                <div className="m-2 p-2">
                  <p className="label">Timeliness </p>
                  <p className="content">
                    {booking ? booking.timeliness || "" : <Skeleton />}
                  </p>
                  <select
                    className="form-select"
                    onChange={(e) => setFeedback(e.target.value)}
                    value={feedback}
                  >
                    <option value="">Select feedback</option>
                    {feedbackDetails?.map((f) => (
                      <option key={f.id} value={f.value}>
                        {f.value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="m-2 p-2">
                  <p className="label"> Service Feedback</p>
                  {booking?.portal_rating ? (
                    <div className="d-flex mb-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <FaStar
                          key={star}
                          size={28}
                          style={{ marginRight: "8px" }}
                          color={
                            star <= (rating || booking?.portal_rating)
                              ? "#ffc107"
                              : "#e4e5e9"
                          }
                        />
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                  <select
                    className="form-select"
                    onChange={(e) => setRating(Number(e.target.value))}
                    value={rating}
                  >
                    <option value="">Select Rating</option>
                    {[1, 2, 3, 4, 5].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div> */}
          <div className="col-md-12 mt-2">
            <div className="row">
              <div className="col-12">
                <p className="sub-heading" style={{ marginLeft: "15px" }}>
                  Followup
                </p>
              </div>
              <div className="col-md-6">
                <div className="m-2 p-2">
                  <p className="label">Customer requested date</p>
                  <input
                    type="date"
                    className="form-control mb-3"
                    onChange={(e) => {
                      setRequestedDate(e.target.value);
                    }}
                    value={requestedDate}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="m-2 p-2">
                  <p className="label"> Vendor follow up schedule date</p>
                  <input
                    type="date"
                    className="form-control mb-3"
                    onChange={(e) => {
                      setVendorScheduledDate(e.target.value);
                    }}
                    value={vendorScheduledDate}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="m-2 p-2">
                  <p className="label">Status of follow-up </p>
                  <p className="content">
                    {booking ? booking.status_followup || "" : <Skeleton />}
                  </p>
                  <select
                    className="form-select"
                    onChange={(e) => setFollowUp(e.target.value)}
                    value={followUp}
                  >
                    <option value="">Select follow-up</option>
                    {followUpList?.map((f) => (
                      <option key={f.id} value={f.value}>
                        {f.value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="m-2 p-2">
                  <p className="label">UtilStop Contact </p>
                  {/* <p className='content'>{booking ? booking.utilstop_contact || "" : <Skeleton />}</p> */}
                  <select
                    disabled={booking?.utilstop_contact}
                    className="form-select"
                    onChange={(e) => setContact(e.target.value)}
                    value={contact ? contact : booking?.utilstop_contact}
                  >
                    <option value="">Select contact</option>
                    {contactDetails?.map((f) => (
                      <option key={f.id} value={f.first_name}>
                        {f.first_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-1 vertical-line mt-2"></div>
        <div className="col-md-5 mt-2 mr-10">
          <div className="m-2 p-2" style={{ width: "100%" }}>
            <h2 className="sub-heading mb-3">Order Confirmation</h2>
            <div
              className="col-md-12"
              style={{ fontSize: "15px", fontWeight: "300px" }}
            >
              <div className="row mb-2">
                <div className="col-4 label">Order Number:</div>
                <div className="col-7 content">
                  {booking ? booking.display_booking_id || "-" : <Skeleton />}
                </div>
              </div>

              {booking?.service_name === "Packers & Movers" ? (
                <>
                  <div className="row mb-2">
                    <div className="col-4 label">Items to be Shifted :</div>
                    <div className="col-7 ">
                      {booking?.service_offering || "-"}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row mb-2">
                    <div className="col-4 label">Selected Service:</div>
                    <div className="col-7 ">
                      {service.includes(booking?.service_name)
                        ? booking?.service_name || "-"
                        : `${booking?.service_name || "-"} - ${
                            booking?.service_type_name || "-"
                          }`}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 label">Selected Type:</div>
                    <div className="col-7 ">
                      {booking?.service_offering || "-"}
                    </div>
                  </div>
                </>
              )}
              {/* {booking?.service_name !== "Packers & Movers" && (
              
            )} */}
              {booking?.service_name === "Packers & Movers" ? (
                <>
                  <div className="row mb-2">
                    <div className="col-4 label">Pickup City, Emirate:</div>
                    <div className="col-7 ">{booking?.from_state || "-"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 label">Drop City, Emirate:</div>
                    <div className="col-7 ">{booking?.to_state || "-"}</div>
                  </div>
                </>
              ) : (
                <div className="row mb-2">
                  <div className="col-4 label">Service Location:</div>
                  <div className="col-7 ">{booking?.service_state || "-"}</div>
                </div>
              )}

              {booking?.service_name === "Packers & Movers" && (
                <div className="row mb-2">
                  <div className="col-4 label">Distance:</div>
                  <div className="col-7 ">{booking?.distance || "-"}</div>
                </div>
              )}

              <div className="row mb-2">
                <div className="col-4 label">Scheduled Date & Time:</div>
                <div className="col-7 ">
                  {booking?.service_date || d[0]?.service_date ? (
                    `${format(
                      parseISO(booking?.service_date || d[0]?.service_date),
                      "dd-MM-yyyy"
                    )} at ${booking?.service_time || "-"}`
                  ) : (
                    <Skeleton />
                  )}
                </div>
              </div>
              {booking?.service_name === "Packers & Movers" && (
                <>
                  <div className="row mb-2">
                    <div className="col-4 label">Pickup Link :</div>
                    <div className="col-7 ">
                      {booking?.pickup_location || "-"}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 label">Drop Link :</div>
                    <div className="col-7 ">
                      {booking?.drop_location || "-"}
                    </div>
                  </div>
                </>
              )}
              {/* {booking?.service_name !== "Packers & Movers" && (
               <div className="row mb-2">
        <div className="col-4 label">Address:</div>
        <div className="col-7 ">{booking?.full_address || '-'}</div>
      </div>
            )} */}
              {booking?.image_list.length > 0 && (
                <div className="row mb-2">
                  <div className="col-4 label">View More:</div>
                  <div className="col-7 ">
                    {booking?.booking_detail_link ? (
                      <a
                        href={booking.booking_detail_link}
                        style={{ color: "#d01c4c" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {booking.booking_detail_link}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              )}

              {booking?.service_name === "Packers & Movers" ? (
                <>
                  <div className="row mb-2">
                    <div className="col-4 label">Pickup Map:</div>
                    <div className="col-7 ">
                      {booking?.pickup_map_link ? (
                        <a
                          href={booking.pickup_map_link}
                          style={{ color: "#d01c4c" }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {booking.pickup_map_link}
                        </a>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 label">Drop Map:</div>
                    <div className="col-7 ">
                      {booking?.drop_map_link ? (
                        <a
                          href={booking.drop_map_link}
                          style={{ color: "#d01c4c" }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {booking.drop_map_link}
                        </a>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className="row mb-2">
                  <div className="col-4 label">Google Map Link:</div>
                  <div className="col-7 ">
                    {booking?.pickup_map_link ? (
                      <a
                        href={booking.pickup_map_link}
                        style={{ color: "#d01c4c" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {booking.pickup_map_link}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              )}
              {(booking?.service_name === "Cleaning Service" ||
                booking?.service_name === "Hourly Deep Cleaning") && (
                <div className="row mb-2">
                  <div className="col-4 label">User Preference:</div>
                  <div className="col-7 ">
                    {booking?.gender || "-"} - {booking?.people_count} Service
                    agents
                  </div>
                </div>
              )}

              <div className="row mb-2">
                <div className="col-4 label">Address:</div>
                <div className="col-7 ">{booking?.full_address || "-"}</div>
              </div>

              <div className="row mb-2">
                <div className="col-4 label">Customer Name:</div>
                <div className="col-7 ">{booking?.user_name || "-"}</div>
              </div>
              <div className="row mb-2">
                <div className="col-4 label">Customer’s Contact:</div>
                <div className="col-7 ">
                  {booking?.user_phone_number || "-"}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-3 pe-4">
          <button
            onClick={handleUpdateBooking}
            className="btn Button primaryBackground text-white d-flex align-items-center justify-content-center"
            style={{
              minWidth: "100px",
              height: "40px",
              fontSize: "14px",
              borderRadius: "6px",
            }}
          >
            {loading ? (
              <Loader style={{ height: "30px", width: "40px" }} />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
      <div className="row">
        <h2 className="sub-heading mb-3"> Customer recent transactions</h2>

        <div className="col-md-12 mt-2">
          <Table
            headers={[...bookingHeaders, "Action"]}
            data={userRecords.map((record) => [
              record.id,
              record.service_name,
              record.service_type_name,
              record.service_offering_name,
              format(parseISO(record.serviceDate), "dd-MM-yyyy"),
              record.service_time,
              record.status,
              record.vendor,
              <button
                className="btn btn-sm"
                onClick={() => handleViewOrder(record.display_booking_id)}
                style={{ minWidth: "100px", color: "#d01c4c" }}
              >
                View
              </button>,
            ])}
            pagination={true}
            recordsCount={5}
          />
        </div>
      </div>
    </div>
  );
};

export default BookingDetails;
